import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Divider, Image, Stack, Text } from '@mantine/core';
import classes from './Divider.module.css';
import { KycCharacter } from './KycCharacter';
export const KycCongrats: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Stack mt={{
    base: 20,
    lg: 0
  }} h={{
    base: 'calc(100vh - 150px)',
    lg: 'calc(100vh - 190px)'
  }} gap={10} p={{
    base: 24,
    sm: 10
  }}>
      <Image src="/assets/kyc/celebration.svg" alt="celebration" w={{
      base: 80,
      sm: 100,
      lg: 112
    }} h={{
      base: 80,
      sm: 100,
      lg: 112
    }} mx={{
      base: 'auto',
      lg: 0
    }} mb={20} />
      <Box>
        <Text fz={{
        sm: 20,
        lg: 32
      }} c="var(--text-prime)" className={gunterzBold.className} ta={{
        base: 'center',
        lg: 'left'
      }}>
          {i18n._('Congrats,')}
        </Text>
        <Text fz={{
        sm: 20,
        lg: 32
      }} c="var(--text-white)" className={gunterzBold.className} ta={{
        base: 'center',
        lg: 'left'
      }}>
          {i18n._(' Armor Unlocked!')}
        </Text>
      </Box>

      <Divider my={14} classNames={classes} />

      <Text fz={{
      sm: 18,
      lg: 20
    }} c="var(--text-dark)" className={gunterzBold.className} ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('You’ve unlocked THE ')}
        <Text span inherit c="var(--text-pink)">
          {i18n._('GALAXY SILVER ')}
        </Text>
        {i18n._('ARMOR')}
      </Text>

      <Divider my={14} classNames={classes} />

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('Your dedication has paid off, and now your PrimeOrb is equipped with the ultimate protection.')}
      </Text>

      <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta={{
      base: 'center',
      lg: 'left'
    }}>
        {i18n._('Feast your eyes on your new armor—only the best for a true PrimeRoller like you!')}
      </Text>

      <KycCharacter visible="sm" hidden="lg" />
    </Stack>;
};